import { ApiService } from "../../index";

export const updateLittleGroupState = (
  little_group_id: string,
  group_state: string
) => {
  return ApiService.baseAction(
    `/little-group/${little_group_id}/update_state`,
    {
      data: {
        state: group_state === "归来" ? "出发" : "归来",
      }
    },
    "post"
  );
};
